import { defineStore } from "pinia"
import { ref } from 'vue'

export const useTalkStore = defineStore('talk', () => {
  const talkLinkUrl = ref<string>('')
  const updateTalkLinkUrl = (newTalkLinkUrl: string) => {
    talkLinkUrl.value = newTalkLinkUrl
  }
  const clearTalkLinkUrl = () => {
    talkLinkUrl.value = ''
  }

  // 現在表示中のURL（route.fullPathだけではなく、表示中にも適宜更新）
  const returnKcloudPath = ref<string>('')
  const updateReturnKcloudPath = (routeFullPath: string) => {
    returnKcloudPath.value = routeFullPath
  }
  return {
    returnKcloudPath,
    updateReturnKcloudPath,
    talkLinkUrl,
    updateTalkLinkUrl,
    clearTalkLinkUrl,
  }
})
